import { RegistrationAlertsServant } from '../servants/registration_alerts_servant';
import { IRegisterSectionsDatasource } from '../datasources/register_sections_datasource';
import { ScheduledSectionStatusServant } from '../servants/scheduled_section_status_servant';
import { ITermCoursesDatasource } from '../../term_courses/datasources/term_courses_datasource';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import { IDefineCommand, IQueryMediator, ICommand, IQuery } from 'core-ts-types';
import { ScheduledSectionStatus } from '../types/scheduled_section_status_enum';
import * as _4 from 'lodash4';
import { ITermSectionTypesDatasource } from '../../term_courses/datasources/term_section_types_datasource';
import { ISectionType } from '../../../interfaces/scheduler_interfaces';
import { RemoveSectionSelectionCommand } from '../../../components/section_selections/commands/remove_section_selection_command';
import { ScheduledSectionRequestStateCommand } from '../../../request_state/commands/scheduled_section_request_state_command';
angular
  .module('capability-ng-scheduler')
  .service(
    'unscheduleCourseSectionsCommand',
    function unscheduleCourseSectionsCommand(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      $q: ng.IQService,
      SectionStatusCollectionBuilder: any,
      ngSectionsDatasource: ISectionsDatasource,
      ngTermCoursesDatasource: ITermCoursesDatasource,
      ngScheduledSectionStatusServant: ScheduledSectionStatusServant,
      QueryMediator: IQueryMediator,
      ngRegisterSectionsDatasource: IRegisterSectionsDatasource,
      ngRegistrationAlertsServant: RegistrationAlertsServant,
      ngTermSectionTypesDatasource: ITermSectionTypesDatasource,
      removeSectionSelectionCommand: RemoveSectionSelectionCommand,
      scheduledSectionRequestStateCommand: ScheduledSectionRequestStateCommand
    ) {
      'use strict';

      return defineCommandORM('unscheduleCourseSectionsCommand', (deferred, termId, courseId, sessionId) => {
        const scheduledSections = _4.filter(ngSectionsDatasource.read(), (section) => {
          return section.course === courseId && ngScheduledSectionStatusServant.isSectionScheduled(section);
        });
        const scheduledSectionsId = scheduledSections.map((section) => section.id);
        scheduledSectionRequestStateCommand(scheduledSectionsId, true);
        let courseDeleteUrl = `/reg/schedule/term/${termId}/course/${courseId}/`;
        if (sessionId && _4.toString(sessionId) !== '-1') {
          const sectionTypeIdsForSession = _4.compact(
            _4.map(
              _4.filter(
                ngTermSectionTypesDatasource.read(),
                (sectionType: ISectionType) => sectionType.session === sessionId
              ),
              'id'
            )
          );
          _4.remove(scheduledSections, (section) => !_4.includes(sectionTypeIdsForSession, section.section_type));
          courseDeleteUrl = `${courseDeleteUrl}session/${sessionId}`;
        }
        return $http
          .delete(`${courseDeleteUrl}`)
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            _4.each(scheduledSections, (section) => {
              const scheduledSection = ngSectionsDatasource.get(section.id);
              if (scheduledSection) {
                scheduledSection.status = ScheduledSectionStatus.UNSCHEDULED;
                ngSectionsDatasource.put(scheduledSection);
              }
              const removeSectionFromReg = ngRegisterSectionsDatasource.get(section.id);
              if (removeSectionFromReg) {
                ngRegisterSectionsDatasource.del(section.id);
                removeSectionSelectionCommand(section.id);
              }
            });
            const updateSectionSelectionPromises: ng.IPromise<IQuery[]>[] = [];
            scheduledSections.map((section) => {
              const scheduledSection = ngSectionsDatasource.get(section.id);
              if (scheduledSection) {
                scheduledSection.status = ScheduledSectionStatus.UNSCHEDULED;
                ngSectionsDatasource.put(scheduledSection);
              }
              const removeSectionFromReg = ngRegisterSectionsDatasource.get(section.id);
              if (removeSectionFromReg) {
                ngRegisterSectionsDatasource.del(section.id);
                updateSectionSelectionPromises.push(removeSectionSelectionCommand(section.id));
              }
            });
            $q.all(updateSectionSelectionPromises).then(() => {
              scheduledSectionRequestStateCommand(scheduledSectionsId, false);
              deferred.resolve(QueryMediator.runQueries(ngSectionsDatasource, ngTermCoursesDatasource));
            });
          })
          .catch(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            scheduledSectionRequestStateCommand(scheduledSectionsId, false);
            ngRegistrationAlertsServant.showUnScheduleAllSectionsFailAlert(scheduledSections);
            deferred.reject(data);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/commands/unschedule_course_sections_command.ts